import React from 'react'
import Layout from '../components/layout'
import { graphql, useStaticQuery, Link } from 'gatsby'
import tagsStyles from './tags.module.scss'

const Tags = () => {
    const data = useStaticQuery(graphql`
    query {
        allMarkdownRemark {
            group(field: frontmatter___tags) {
                    fieldValue
                    totalCount
            }
        }
    }
`)
console.log(data.allMarkdownRemark.group[0].fieldValue)
    return (
        <Layout>
            {data.allMarkdownRemark.group.map((tag) => {
                return(<div>
                    <div className={tagsStyles.tag}>
                        <Link to={`/tags/${tag.fieldValue}`}>{tag.fieldValue}</Link>
                        <section> {tag.totalCount}</section>
                    </div>
                    </div>)
            })}
        </Layout>
    )
}

export default Tags